/**
 * Strips any trailing forward slash characters (`'/'`) from the given `url`.
 *
 * @param url The URL to transform.
 * @returns The given `url` after removing any and all trailing forward slashes.
 */
export function removeTrailingSlash(url?: string) {
  return url?.trim().replace(/\/+$/, '')
}

/**
 * Ensures the given `url` ends with a single forward slash (`'/'`).
 *
 * @param url The URL to transform.
 * @returns The given `url` with a trailing slash.
 */
export function ensureTrailingSlash(url?: string) {
  return url ? `${removeTrailingSlash(url)}/` : url
}
